<template>
  <div id="app" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <!-- 登出按鈕 -->
    <div style="position: absolute; left: 20px; top: 15px;">
      <el-button @click="gotoCheckout" plain>{{ $t('Store.back') }}</el-button>
    </div>
    <div style="padding-top: 20px;">
      <!-- 選擇類型 -->
      <el-radio-group v-model="radio" fill="#666" @change="getType">
        <el-radio-button label="ComsumeHistory">{{ $t('Store.consumption') }}</el-radio-button>
        <el-radio-button label="ExchangeHistory">{{ $t('Store.redeem') }}</el-radio-button>
        <el-radio-button label="SendHistory">{{ $t('Store.topup') }}</el-radio-button>
        <el-radio-button label="Undo">{{ $t('Store.cancel') }}</el-radio-button>
      </el-radio-group>
      <mu-text-field v-model="searchPhone" style="width: 180px; margin-left: 40px;" action-icon="search" :placeholder="$t('Store.searchphone')"></mu-text-field>
      <br>
      <!-- 取消 -->
      <div style="padding-left: 10px; padding-bottom: 10px;">
        <el-radio-group v-model="undoType" v-if="radio === 'Undo'" @change="getType">
          <el-radio label="UndoHistory">{{ $t('Store.consumption') }}</el-radio>
          <el-radio label="UndoExchange">{{ $t('Store.redeem') }}</el-radio>
          <el-radio label="UndoSend">{{ $t('Store.topup') }}</el-radio>
        </el-radio-group>
      </div>
      <!-- 選擇時間 -->
      <div class="block">
        <!-- <div>基於後台使用順暢度考量，消費記錄已改為使用時間區間查詢。</div>
        <div style="margin-bottom: 10px;">提醒您，查詢的時間區段太長將導致資料載入速度變慢。</div> -->
        <!-- 起始日 -->
        <el-date-picker v-model="start"
          style="width: 150px;"
          align="right"
          type="date"
          placeholder="選擇起始日"
          :picker-options="pickerOptions">
        </el-date-picker> -
        <!-- 到期日 -->
        <el-date-picker v-model="end"
          align="right"
          style="width: 150px; margin-right: 10px;"
          type="date"
          placeholder="選擇到期日"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" @click="getType(radio, true)" :disabled="!start || !end">查詢</el-button>
      </div>
      <!-- 消費記錄 -->
      <div class="grid-content bg-purple-light">
        <el-table  :key="Math.random()" :data="finalList[pageTab]" :empty-text="$t('Store.noinfo')" :height="windowHeight" style="width: 100%">
          <!-- 時間 -->
          <el-table-column prop="Time"
            :label="$t('Store.time')"
            width="200">
            <template slot-scope="scope">{{ getTime(scope.row[1].Time) }}</template>
          </el-table-column>
          <!-- 電話 -->
          <el-table-column prop="Phone"
            :label="$t('Store.phone')"
            width="130">
            <template slot-scope="scope">{{ scope.row[1].Phone }}</template>
          </el-table-column>

          <!-- 金額 -->
          <el-table-column prop="Price" :label="$t('Store.amount')" v-if="radio === 'ComsumeHistory' || (radio === 'Undo' && undoType === 'UndoHistory')">
            <template slot-scope="scope"><span style="font-weight: 500; font-size: 15px;" :style="{ color: scope.row[1].Price < 0 ? style.red : style.default }">{{ scope.row[1].Price }}</span></template>
          </el-table-column>

          <!-- 點數 -->
          <el-table-column prop="Point" :label="$t('Store.point')" v-if="checkEnable()">
            <template slot-scope="scope"><span style="font-weight: 500; font-size: 15px;">{{ scope.row[1].Point }}</span></template>
          </el-table-column>

          <!-- 消費操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'ComsumeHistory'">
            <template slot-scope="scope">
              <!-- 已退款 -->
              <el-button size="mini" type="info" v-if="scope.row[1].Status === 'refund'" disabled>{{ $t('Store.refunded') }}</el-button>
              <!-- 退款 -->
              <el-button size="mini" @click="checkReverse(scope.row, 'Refund')" type="primary" v-if="scope.row[1].Price > 0 && scope.row[1].Status !== 'refund'">{{ $t('Store.refund') }}</el-button>
              <!-- 取消交易 -->
              <el-button size="mini" @click="checkReverse(scope.row, 'comsume')" type="danger" v-if="scope.row[1].Status !== 'refund'">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>

          <!-- 兑點操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'ExchangeHistory'">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="checkReverse(scope.row, 'exchange')">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>

          <!-- 贈點操作 -->
          <el-table-column prop="Edit" width="180" :label="$t('Store.operate')" v-if="radio === 'SendHistory'">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="checkReverse(scope.row, 'send')">{{ $t('Store.cancel') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 取消 Dialog -->
        <mu-dialog  :title="$t('Store.system')" width="600" :open="reverseDia">
          <!-- 驗證碼 -->
          <el-input type="password" :placeholder="$t('Store.please_ver')" v-model="verCode" @focus="type = 'vercode'">
            <template slot="prepend">{{ $t('Store.vercode') }}</template>
          </el-input>
          <!-- 店員編號 -->
          <el-input :placeholder="$t('Store.please_employee')" v-model="employee" @focus="type = 'employee'">
            <template slot="prepend">{{ $t('Store.employee') }}</template>
          </el-input>
          <!-- 鍵盤 -->
          <keyboard @addNum="addNum" @clear="clear"/>
          <!-- 按鈕 -->
          <mu-button slot="actions" flat color="primary" @click="reverseDia = false">{{ $t('Store.back') }}</mu-button>
          <mu-button slot="actions" color="primary" @click="sendReverse">{{ $t('Store.check') }}</mu-button>
          <!-- 錯誤文字 -->
          <div style="color: #f24;">{{ $t(noVer) }}</div>
          <div style="color: #f24;">{{ $t(noEmployee) }}</div>
        </mu-dialog>
        <!-- 成功訊息 -->
        <mu-dialog :title="$t('Store.success')" width="600" :open="completeDia" @close="completeDia = false">
          {{ $t('Store.update_succeed') }}<br>
          {{ $t('Store.phone') }}: {{ phone }}<br>
          {{ $t('Store.remain_point') }}: {{ newPoint }}
        </mu-dialog>
        <!-- 重整頁面 -->
        <div style="text-align: center; padding-top: 5px;">
          <!-- 選單 -->
          <el-pagination background
            @current-change="changePage"
            style="margin-top: 10px;"
            :page-size="1"
            layout="prev, pager, next"
            :total="totalNum">
          </el-pagination>
          <!-- 刷新按鈕 -->
          <el-button style="margin-top: 15px;" type="info" @click="getType(radio, true)">{{ $t('Store.refresh') }}
            <i class="el-icon-refresh"></i>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import keyboard                   from './keyboard';

export default {
  data() {
    return {
      service: this.$route.params.service,
      AuthToken: this.$route.params.Auth_u,
      storeid: this.$route.query.storeid,
      pageLoading: false,
      completeDia: false,
      searchPhone: '',
      type: '',
      undoType: 'UndoHistory',
      radio: 'ComsumeHistory',
      style: {
        default: '#666',
        red: '#f24'
      },
      reverseDia: false,
      reverseType: '',
      reverseData: [],
      pageTab: 0,
      totalNum: 0,
      noVer: '',
      verCode: '',
      noEmployee: '',
      employee: '',
      phone: '',
      newPoint: '',
      windowHeight: window.screen.height * 0.45,
      tableData: [],
      tableData2: [],
      finalList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      start: Date.now(),
      end: Date.now()
    }
  },
  props: [],
  components: {
    keyboard
  },
  mounted() {
    const comsumeList  = this.AllList['ComsumeHistory'];
    const pageDataList = Object.keys(this.pageData);
    // this.getListByType('ComsumeHistory')
    this.getPage(pageDataList);
  },
  computed: {
    ...mapGetters({
      AllList: 'AllList',
      pageData: 'pageData'
    })
  },
  methods: {
    ...mapActions({
      getAllHistory: 'getAllHistory',
      getSuccessMessage: 'getSuccessMessage',
      checkAccount: 'checkAccount',
      reverseComsume: 'reverseComsume',
      comsumeBroadcast: 'comsumeBroadcast',
      getPoints: 'getPoints'
    }),
    checkEnable() {
      if (this.radio === 'ComsumeHistory') {
        return false;
      }
      if (this.radio === 'Undo' && this.undoType === 'UndoHistory') {
        return false;
      }
      return true;
    },
    // 取得日期格式
    getTime(time) {
      const realTime = new Date(time);
      return realTime.toLocaleString('en-US', { timeZone: this.timezone });
    },
    addNum(val) {
      if (this.type === 'vercode')  this.verCode  += val;
      if (this.type === 'employee') this.employee += val;
    },
    clear() {
      if (this.type === 'vercode')  this.verCode  = '';
      if (this.type === 'employee') this.employee = '';
    },
    getPage(list) {
      if (list.length <= 1) {
        this.checkAccount({ Service: this.service, Auth: this.AuthToken });
      }
    },
    changePage(val) {
      this.pageTab = val - 1
    },
    checkReverse(row, type) {
      this.reverseDia  = true;
      this.reverseType = type;
      this.reverseData = row;
      this.employee    = '';
      this.verCode     = '';
      this.noVer       = '';
      this.noEmployee  = '';
    },
    gotoCheckout() {
      this.$router.push(`/shop/${this.service}/${this.AuthToken}?storeid=${this.storeid}`);
    },
    getType(type, boolean) {
      this.totalNum  = 0;
      this.pageTab   = 0;
      const searchType = (type === 'Undo') ? this.undoType : type;
      const recordList = this.AllList[searchType];
      if (recordList && recordList.length > 0 && !boolean) {
        this.tableData  = recordList.sort((a, b) => b[1].Time - a[1].Time);
        this.tableData2 = recordList.sort((a, b) => b[1].Time - a[1].Time);
        this.recalculateList();
      }
      else {
        this.getListByType(searchType);
      }
    },
    prepareData(phone, point, price, ratio, expRatio, key) {
      const type = this.reverseType;
      this.pageLoading = true;
      this.getPoints({ service: this.service, auth: this.AuthToken, phone: phone })
        .then((res) => {
          const token = res.userid;
          let newPoints = 0;
          let returnExp = 0;
          let points = point;
          // 類型
          if (type === 'exchange') {
            newPoints = parseInt(res.MemberPoints) + point;
          }
          else if (type === 'send') {
            newPoints = parseInt(res.MemberPoints) - point;
          }
          else {
            newPoints = parseInt(res.MemberPoints) - parseInt(price / ratio);
            points = parseInt(price / ratio);
            returnExp = price * expRatio;
          }
          const msgType = (type === 'comsume') ? 'Undo' : (type === 'Refund') ? 'Refund' : 'UnExchange';
          this.reverseComsume({ service: this.service, auth: this.AuthToken, token: token, point: points, returnExp: returnExp, store: this.storeid, key: key, undoType: type, employee: this.employee })
            .then(() => {
              if (this.radio === 'Undo') {
                this.getListByType(this.undoType);
              }
              else {
                this.getListByType(this.radio);
              }
              this.pageLoading = false;
              this.verCode     = '';
              this.employee    = '';
              this.phone       = phone;
              this.newPoint    = newPoints;
              this.completeDia = true;
            })
          this.getSuccessMessage({ service: this.service, auth: this.AuthToken, type: msgType })
            .then((_msg) => {
              const successResponse = _msg.replace(/@ELS_REMAIN/g, newPoints);
              this.comsumeBroadcast({ service: this.service, auth: this.AuthToken, token: token, message: successResponse });
            })
        })
    },
    sendReverse() {
      this.reverseDia = false;
      this.noVer = '';
      this.noEmployee = '';
      // console.log(this.reverseType);
      if (this.pageData.undotax && this.verCode !== this.pageData.undotax) {
        this.noVer = 'Store.warning2';
        return;
      }
      else if (this.pageData.undotax && this.verCode !== this.pageData.taxid) {
        this.noVer = 'Store.warning2';
        return;
      }
      // 員工
      if (this.employee === '') {
        this.noEmployee = 'Store.no_employee_id';
        return;
      }
      const key   = this.reverseData[0];
      const phone = this.reverseData[1].Phone;
      const point = this.reverseData[1].Point ? parseInt(this.reverseData[1].Point) : 0;
      const price = this.reverseData[1].Price ? parseInt(this.reverseData[1].Price) : 0;
      const ratio = this.pageData.ratio ? parseInt(this.pageData.ratio) : 50;
      const expRatio = this.pageData.expRatio ? this.pageData.expRatio : 0;
      // 準備送出
      // console.log(expRatio);
      this.prepareData(phone, point, price, ratio, expRatio, key);
    },
    recalculateList() {
      this.totalNum = Math.floor(this.tableData2.length / 10) + 1;
      for (let i = 0; i < this.totalNum; i += 1) {
        this.finalList[i] = [];
      }
      for (let e = 0; e < this.tableData2.length; e += 1) {
        const index = e;
        const group = parseInt(index / 10);
        const orderData = this.tableData2[index];
        this.finalList[group].push(orderData)
      }
    },
    getListByType(type) {
      this.pageLoading = true;
      this.getAllHistory({ service: this.service, auth: this.AuthToken, store: this.storeid, path: type, start: new Date(this.start).getTime(), end: new Date(this.end).getTime() + (86400 * 1000) })
        .then(() => {
          this.pageLoading = false;
          this.tableData  = this.AllList[type] ? this.AllList[type].sort((a, b) => b[1].Time - a[1].Time) : [];
          this.tableData2 = this.AllList[type] ? this.AllList[type].sort((a, b) => b[1].Time - a[1].Time) : [];
          this.recalculateList();
        })
    }
  },
  watch: {
    // 查詢記錄
    searchPhone(val) {
      this.tableData2 = this.tableData.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.recalculateList();
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins');
.sendButton {
  background-color: #67c23a !important;
  color: #fff !important;
  border-radius: 0 3px 3px 0 !important;
  border: none !important;
}
.sendButton:hover {
  opacity: 0.8;
}
.el-input {
  margin-bottom: 25px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  padding: 0;
  border-radius: 4px;
}
.bg-purple-dark {
  background: #666;
}
.bg-purple {
  background: #777;
}
.grid-content {
  margin: 0 auto;
  border-radius: 4px;
  min-height: 36px;
  max-width: 630px;
  margin-bottom: 10px;
  text-align: left;
}
.web {
  text-decoration: none;
  color: black;
  transition: 0.2s;
}
.web:hover {
  color: #f24;
}
</style>